module.exports = __webpack_public_path__ + "af3c375c4456b56c281a75328b4b801e.png";